import { bookingConfig } from '@cocoonspace/shared/config/booking-config'
import { ChevronDown, Users, X } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import {
	DrawerPopover,
	DrawerPopoverContent,
	DrawerPopoverTrigger,
} from '~/components/drawer-dialog'
import { Card } from '~/components/ui/card'
import { cn } from '~/lib/utils'

export const SearchCapacityFilter = ({
	onChange,
	value,
	className,
}: {
	onChange: (type?: string) => void
	value: string
	className?: string
}) => {
	const { t } = useTranslation()
	const [isOpen, setIsOpen] = useState(false)

	return (
		<DrawerPopover
			open={isOpen}
			onOpenChange={setIsOpen}
		>
			<Card
				className={cn(
					'flex h-[32px] flex-row items-center rounded text-sm',
					className,
				)}
			>
				<DrawerPopoverTrigger
					className='flex flex-1 flex-row items-center gap-2 p-2'
					data-testid='floating-input'
				>
					<Users
						size={14}
						className='text-primary'
					/>

					<div>
						{value
							? bookingConfig.capacities.find((cap) => cap.value === value)
									?.label
							: t('search:capacityFilter.participants')}
					</div>

					{!value && (
						<ChevronDown
							size={16}
							strokeWidth={1}
							className='shrink-0'
						/>
					)}
				</DrawerPopoverTrigger>

				{!!value && (
					<button
						type='button'
						className='pr-2'
						onClick={(e) => {
							e.preventDefault()
							e.stopPropagation()
							onChange(undefined)
							setIsOpen(false)
						}}
					>
						<X
							className='text-primary'
							size={16}
						/>
					</button>
				)}
			</Card>

			<DrawerPopoverContent
				sideOffset={10}
				className='!p-0 overflow-hidden md:w-[80px]'
				onOpenAutoFocus={(e) => e.preventDefault()}
			>
				{bookingConfig.capacities.map((option, i) => (
					<button
						type='button'
						key={option.label}
						data-testid={`capacity-option-${i}`}
						className={cn(
							'w-full truncate px-4 py-2 text-left text-sm',
							option.label === value
								? 'bg-primary/15'
								: 'hover:bg-slate-200/30',
						)}
						onClick={() => {
							onChange(option.value)
							setIsOpen(false)
						}}
					>
						{option.label}
					</button>
				))}
			</DrawerPopoverContent>
		</DrawerPopover>
	)
}
